<template>
  <div class="page-layout" :class="!hiddenBreadCrumb && 'has-breadcrumb'">
    <div v-if="!hiddenBreadCrumb" class="breadcrumb-navigation">
      <div
        v-for="(item, index) in breadcrumbList"
        class="breadcrumb-item"
        :key="index"
      >
        <router-link class="link" :to="item.to">{{ item.label || $t(item.labelI18nKey) }}</router-link>
        <span class="separator">/</span>
      </div>
    </div>
    <div class="page-layout-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    hiddenBreadCrumb: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    breadcrumbList () {
      const vm = this
      const currentRoute = this.$route
      let route = currentRoute
      let meta = route.meta
      const breadcrumbList = []
      while (meta && !meta.isRootLayout) {
        if (meta.breadcrumb?.hidden) {
          route = meta._parent
          meta = route.meta
          continue
        }
        breadcrumbList.push({
          route,
          meta,
          get to () {
            const path = this.route.path
            const to = { }
            if (path.includes(':')) {
              if (this.route.name) {
                to.name = this.route.name
                to.params = currentRoute.params
              } else {
                to.path = path
                _.forEach(currentRoute.params, (val, name) => {
                  const reg = new RegExp(`:${name}[^/]*`)
                  to.path = to.path.replace(reg, val)
                })
              }
            } else {
              to.path = path
            }
            return to
          },
          get label () {
            const meta = this.meta
            if (meta.breadcrumb) {
              return meta.breadcrumb.label || vm.$t(meta.breadcrumb.labelI18nKey)
            } else if (meta.menu) {
              return meta.menu.label || vm.$t(meta.menu.labelI18nKey)
            } else {
              return meta.title || vm.$t(meta.titleI18nKey)
            }
          }
        })

        if (!meta._parent) {
          break
        }

        route = meta._parent
        meta = route.meta
      }
      return _.reverse(breadcrumbList)
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.page-layout {
  padding-top: 25px;
  position: relative;

  .breadcrumb-navigation {
    position: absolute;
    top: -8px;
    left: 0;

    .breadcrumb-item {
      display: inline-block;
      color: #606266;

      &:last-child {
        .link {
          color: #606266;
          cursor: default;
        }

        .separator {
          display: none;
        }
      }

      .separator {
        margin: 0 5px;
        color: #606266;
      }
    }
  }

  .page-layout-content {
    padding: 24px;
    background: #ffffff;
    min-height: 100%;
  }
}
</style>
